<template>
	<div
		class="base_text"
		ref="about_content"
		:class="{
       'base_ellipsis':!more,
       'base_ellipsis_2':more&&number === 2
    }"
	>
		<div ref="about_content_box">{{text}}</div>

		<span v-if="showMore&&haveMore" @click="more = !more" class="btn">
			<span v-if="more" class="dian">...</span>
			{{more?'展开':'收起'}} <van-icon :name="more?'arrow-down':'arrow-up'" />
		</span>
	</div>
</template>
<script>
export default {
    name: 'BaseEllipsis',
    data () {
        return {
            more: true,
            showMore: false
        }
    },
    props: {
        text: {
            type: String,
            default: ''
        },
        number: {
            type: Number,
            default: 3
        },
        haveMore: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        text: function (val) {
            if (val) {
                this.info()
            }
        }
    },
    mounted () {
        this.info()
    },
    methods: {
        info () {
            this.$nextTick(() => {
                let { about_content, about_content_box } = this.$refs
                if (about_content && about_content_box) {
                    this.showMore = about_content.offsetHeight < about_content_box.offsetHeight
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.base_text.base_ellipsis {
	max-height: none;
}
.base_text.base_ellipsis span {
	top: unset;
	bottom: 0;
}
.base_ellipsis_2 {
	max-height: 77px !important;
}
.base_text {
	color: #8f959e;
	font-size: 24px;
	line-height: 39px;
	position: relative;
	max-height: 116px;
	overflow: hidden;
	animation: all 1s;
	.btn {
		position: absolute;
		color: @primary;
		bottom: 0;
		right: 0;
		background-color: #ffffff;
	}
	.dian {
		color: #8f959e;
	}
	// &::before{
	//     content: '';
	//     float: right;
	//     height: 100%;
	//     margin-bottom: -39px;
	// }
}
</style>